<template>
  <el-dialog title="收费标准" :visible.sync="dialogTableVisible" width="1200px">
    <el-descriptions title="基本信息" :column="2">
      <el-descriptions-item label="名称">{{ detail.name }}</el-descriptions-item>
      <el-descriptions-item label="收费类型">{{ chargePlanTypes[detail.type] }}</el-descriptions-item>
      <el-descriptions-item label="单次充电费用">￥{{ detail.singelCharge }}</el-descriptions-item>
      <el-descriptions-item label="关联小区数">{{ detail.relateAreaNum }}</el-descriptions-item>
      <el-descriptions-item label="计费方式" v-if="[1, 2].indexOf(detail.type) !== -1">{{ billingMethod[detail.powerType] }}</el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="收费标准" :column="2" class="mt-30px">
      <el-descriptions-item label="电费" v-if="[2, 3].indexOf(detail.type) !== -1">{{ detail.electricCharge }}元/度</el-descriptions-item>
      <el-descriptions-item label="服务费" v-if="[1, 2].indexOf(detail.type) !== -1">
        <div>
          <div v-for="(chargePlanItem, index) in detail.chargePlanPowerBeanList" :key="index">
            {{ chargePlanItem.price }}元/1小时({{ chargePlanItem.minPower }}W-{{
              chargePlanItem.maxPower
            }}W)
          </div>
        </div>
      </el-descriptions-item>
      <el-descriptions-item label="服务费" v-if="[3].indexOf(detail.type) !== -1">{{ detail.serviceCharge }}元/度</el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
import {
  orderFeeStandardDetailApi
} from '@/api/order'

export default {
  data() {
    return {
      dialogTableVisible: false,
      detail: {},
      chargePlanTypes: {
        1: '功率计费',
        2: '功率+电费',
        3: '服务费+电费',
      },
      billingMethod: {
        1: '最大功率收费',
        2: '平均功率收费',
      }
    }
  },
  methods: {
    open(row) {
      this.code = row.refChargePlanCode
      this.getFeeStandardDetail()
      this.dialogTableVisible = true
    },

    getFeeStandardDetail() {
      orderFeeStandardDetailApi(this.code).then((res) => {
        this.detail = res.data.chargePlan
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
